// @ts-check
/* eslint-env browser */

/** @typedef {import('../base-map/index.js').BaseMap} BaseMap */

class ZoomButtons extends HTMLElement {
  connectedCallback () {
    const mapContainer = this.closest('map-container')
    if (!mapContainer) return

    const buttons = this.querySelectorAll('button')
    const zoomIn = buttons[0]
    const zoomOut = buttons[1]
    if (!zoomIn || !zoomOut) return

    zoomIn.addEventListener('click', () => {
      /** @type {BaseMap | null} */
      const baseMap = mapContainer.querySelector('base-map')
      baseMap?.zoom('in')
    })
    zoomOut.addEventListener('click', () => {
      /** @type {BaseMap | null} */
      const baseMap = mapContainer.querySelector('base-map')
      baseMap?.zoom('out')
    })
  }
}

customElements.define('zoom-buttons', ZoomButtons)
